import type { Timeseries } from '../../../core/types/timeseries.js';
import type { TimeseriesChartVisualProps } from '../../types/timeseries.js';

/**
 * Props for the TimeseriesChart.Bar slot component
 * @public
 */
export interface TimeseriesChartBarProps extends TimeseriesChartVisualProps {
  /** The series data passed to the bar */
  data: Timeseries;
}

/**
 * @public
 */
export const Bar = (props: TimeseriesChartBarProps) => null;

Bar['displayName'] = 'TimeseriesChart.Bar';
